import { useContext } from 'react'
import * as SETTINGS from '../../../../constants/settings'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import { toastSuccess } from '../../../../utils/toast'
import Tooltip from '../../../Utilities/Tooltip'

const PasswordReset = () => {
  const { [SETTINGS.PASSWORD_RESET.key]: link, updateSetting } =
    useContext(SiteConfigContext)

  const handleSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const data = formData.get('link')
    await updateSetting(SETTINGS.PASSWORD_RESET, data)
    toastSuccess('Password Reset Link saved.')
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center">
        <h2 className="mr-3">Password Reset Link</h2>
        <Tooltip>
          Enter the URL for the password reset page. This link allows users to
          reset their passwords. Click Save to update the setting.
        </Tooltip>
      </div>
      <form
        onSubmit={(e) => handleSubmit(e)}
        autoComplete="off"
        className="flex gap-2"
      >
        <input
          id="link"
          name="link"
          defaultValue={link}
          className="input block w-full"
          placeholder="Password Reset Link"
          required
        />
        <button
          type="submit"
          aria-label="Save Password Reset Link"
          className="button-confirm w-fit"
        >
          Save
        </button>
      </form>
    </div>
  )
}

export default PasswordReset
